import Vue, { PropType } from "vue";
import {
  ArrowKeysSettings,
  SpacebarKeySettings,
  AfterWordActionType,
  Provider,
} from "js/crossword/types";
import { ISettingsData } from "js/crossword/settingsData";
import { Checkbox, RadioButton } from "./FormElements";
import OS from "framework/utils/OS";

import style from "../css/SettingsPopup.module.css";

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    settings: Object as PropType<ISettingsData>,
    hideLayoutOptions: Boolean,
  },
  render() {
    return (
      <div>
        <div class={style.categoryLabel}>
          {this.localization.get("Experience")}
        </div>
        <div class={style.indentContainer}>
          <Checkbox
            class={style.inputElement}
            label={this.localization.get("Timer")}
            target={this.settings}
            targetKey="timer" />
          <Checkbox
            class={style.inputElement}
            label={this.localization.get("Progress bar")}
            target={this.settings}
            targetKey="progressBar" />
        </div>

        {
          OS.desktop && !this.hideLayoutOptions ? (
            <div>
              <div class={style.categoryLabel}>
                {this.localization.get("Placement of clues")}
              </div>
              <div class={style.indentContainer}>
                <RadioButton
                  class={style.inputElement}
                  label={this.localization.get("Right")}
                  target={this.settings}
                  targetKey="leftClues"
                  value={false} />
                <RadioButton
                  class={style.inputElement}
                  label={this.localization.get("Left")}
                  target={this.settings}
                  targetKey="leftClues"
                  value={true} />
              </div>
            </div>
          ) : null
        }

        <div class={style.categoryLabel}>
          {this.localization.get("Navigation")}
        </div>
        <div class={style.indentContainer}>
          <div>
            { OS.desktop ? (
              <div>
                <legend>
                  {this.localization.get("After changing directions with arrow keys:")}
                </legend>
                <RadioButton
                  class={style.inputElement}
                  label={this.localization.get("Stay within the same square")}
                  target={this.settings}
                  targetKey="arrowKeys"
                  value={ArrowKeysSettings.Stay}
                />
                <RadioButton
                  class={style.inputElement}
                  label={this.localization.get("Move in the direction of the arrow")}
                  target={this.settings}
                  targetKey="arrowKeys"
                  value={ArrowKeysSettings.Move}
                />

                <div class={style.spacer}></div>
              </div>
            ) : null }

            <legend>
              {this.localization.get("Pressing spacebar will:")}
            </legend>
            <RadioButton
              class={style.inputElement}
              label={this.localization.get("Clear the current square and advance")}
              target={this.settings}
              targetKey="spaceBar"
              value={SpacebarKeySettings.ClearAndMoveAhead}
            />
            <RadioButton
              class={style.inputElement}
              label={this.localization.get("Toggle between Across and Down")}
              target={this.settings}
              targetKey="spaceBar"
              value={SpacebarKeySettings.ToggleDirection}
            />

            <div class={style.spacer}></div>
          </div>

          <legend>
            {this.localization.get("Within each word:")}
          </legend>
          <Checkbox
            class={style.inputElement}
            label={this.localization.get("Skip over already filled squares")}
            target={this.settings}
            targetKey="skipOverFilledSquares"
          />

          <div class={style.spacer}></div>

          <legend>
            {this.localization.get("After each word move to:")}
          </legend>
          <Checkbox
            class={style.inputElement}
            label={this.localization.get("The first blank in the word (if any)")}
            target={this.settings.afterWordMoveTo}
            targetKey={AfterWordActionType.FirstBlankInSameWord}
          />
          <Checkbox
            class={style.inputElement}
            label={this.localization.get("The next clue (if not moving back)")}
            target={this.settings.afterWordMoveTo}
            targetKey={AfterWordActionType.NextClue}
          />
        </div>
      </div>
    );
  },
});
